/**
 * TrustVid auth brand assets and colors (trustvid.ai wordmark palette).
 */

const trustvidWordmark = require("../../../assets/images/trustvid-wordmark.png");
const trustvidLogoMark = require("../../../assets/images/trustvid-wordmark.png");

/** Colors from the official trustvid wordmark */
export const TRUSTVID_AUTH_BRAND = Object.freeze({
  primary: "#7b3996",
  primaryDark: "#441f54",
  primaryDeep: "#3a1a47",
  accent: "#f9a066",
  text: "#3d3d43",
  muted: "#616161",
  navy: "#1c2541",
  canvas: "#f4f5f8",
});

export { trustvidWordmark, trustvidLogoMark };
